import { render } from "./Addnum.vue?vue&type=template&id=15ae2120&scoped=true"
import script from "./Addnum.vue?vue&type=script&lang=js"
export * from "./Addnum.vue?vue&type=script&lang=js"

import "./Addnum.vue?vue&type=style&index=0&id=15ae2120&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ae2120"]])

export default __exports__